export const HACKATHONS = [
  {
    name: "Project Stellar",
    site: "https://projectstellar.ca",
    date: "June 2026",
    location: "Vancouver, Canada",
    placement: "3rd place",
    project: {
      name: "Launchpad3D",
      description: "A bottle rocket launch tracker which visualizes your launch data.",
      repo: "https://github.com/Tinkering-Townsperson/Launchpad3D",
      demo: "https://youtube.com/shorts/ZPmIsMsO89A"
    }
  },
  {
    name: "Equinox Vancouver",
    site: "https://www.equinoxvancouverhackathon.com/",
    date: "March 2026",
    location: "Vancouver, Canada",
    placement: "2nd place",
    project: {
      name: "Blossom",
      description: "A beautiful focused garden for your productivity. Plant trees and grow your forest while staying away from distractions.",
      repo: "https://github.com/stickmanned/Blossom",
      demo: "https://chromewebstore.google.com/detail/blossom/nenigencnjokhofbmogblicfieakgplj"
    }
  },
  {
    name: "Daydream",
    site: "https://daydream.bcydc.ca/",
    date: "September 2025",
    location: "Vancouver, Canada",
    project: {
      name: "Twin Chaser",
      description: "A 2-player platformer game where the players control two characters, inspired by my real life friends the twins, who chase each other around. One must attempt to catch the other, while the other must avoid being caught.",
      repo: "https://github.com/Tinkering-Townsperson/daydream-project",
      demo: "https://afternoonpm.itch.io/twin-chaser"
    }
  },
  {
    name: "Undercity",
    site: "https://undercity.hackclub.com/",
    date: "July 2025",
    location: "San Francisco, United States",
    project: {
      name: "Nerf-Light",
      description: "A single-player version of red light, green light, made in Hack Club's Undercity Hackathon in July 2025.",
      repo: "https://github.com/Tinkering-Townsperson/Nerf-Light",
      demo: "https://youtu.be/M8pHXFLeqDg?si=-U8EGATkOHG0eR09"
    }
  },
  {
    name: "Juice",
    site: "https://github.com/hackclub/juice/blob/main/README.md",
    date: "April 2025",
    location: "Shanghai, China",
    project: {
      name: "SpaceGoose",
      description: "A 2D platformer made for Hack Club's Juice Game Jam in April 2025.",
      repo: "https://github.com/FraserHackClub/SpaceGoose",
      demo: "https://fraserhackclub.itch.io/spacegoose"
    }
  },
  {
    name: "YVRHacks 2024",
    site: "https://yvrhacks.ca/",
    date: "September 2024",
    location: "Vancouver, Canada",
    project: {
      name: "Chunky",
      description: "Chunky is a desktop assistant that breaks down assignments into manageable tasks, helping students stay focused and productive.",
      repo: "https://github.com/TinkerTown-SEMI/Chunky",
      demo: "https://youtu.be/e3FuyL7rdJk?si=0sUcSTiYpD9c-xod"
    }
  }
]
